import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

import { QUANTITY_INPUT } from '@/constants/quantity_input'
import { isBulkOrBulkIntegrationEnabledSelector } from '@/selectors'

const QuantityInput = ({ id, quantity, handleUpdateQuantity }) => {
  const quantityInputId = `quantity-${id}`
  const isBulkOrBulkIntegrationEnabled = useSelector(
    isBulkOrBulkIntegrationEnabledSelector
  )

  return (
    <>
      <If condition={isBulkOrBulkIntegrationEnabled}>
        <div className='d-flex flex-column u-gap-half mr-2'>
          <label className='u-weight--medium' htmlFor={quantityInputId}>
            <FormattedMessage id='common.quantity' />
          </label>
          <input
            id={quantityInputId}
            max={QUANTITY_INPUT.max_value}
            maxLength={QUANTITY_INPUT.max_length}
            min={QUANTITY_INPUT.min_value}
            name='quantity'
            onChange={e => handleUpdateQuantity(Number(e.target.value))}
            step='1'
            type='number'
            value={quantity}
          />
        </div>
      </If>
    </>
  )
}

export default QuantityInput

QuantityInput.propTypes = {
  handleUpdateQuantity: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  quantity: PropTypes.number.isRequired
}
